<div class="top-vendors">
  <div class="header">
    <button type="button" class="card-title-link" (click)="navigateToVendorsList()">
      <span class="ct-badge"><i class="material-icons">storefront</i></span>
      <span class="ct-text">Top Vendors</span>
      <i class="material-icons ct-arrow">chevron_right</i>
    </button>
    <div class="fs-field">
      <span class="fs-label">Month</span>
      <select
        class="native-select has-icon icon-cal"
        aria-label="Month"
        (change)="onMonthChange($any($event.target).value)"
      >
        <option *ngFor="let o of monthDropdownOptions" [value]="o.value" [selected]="o.value === selectedOption">{{ o.label }}</option>
      </select>
    </div>
  </div>
  <div class="top-vendor-chart">
    <ng-container *ngIf="vendorDetails.length > 0; else noDataTemplate">
      <div class="chart-row">
        <div class="chart-holder">
          <p-chart
            type="doughnut"
            [data]="chartData"
            [options]="chartOptions"
          ></p-chart>
        </div>
        <div class="vendor-names-side" *ngIf="vendorLegendItems.length > 0">
          <div class="vendor-name-item" *ngFor="let vendor of vendorLegendItems">
            <div class="circle" [style.background-color]="vendor.color"></div>
            <span class="label">{{ vendor.label }}</span>
            <span class="value">{{ vendor.value }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <h2 class="empty-state-title">{{ errorMessage }}</h2>
        <img
          [src]="imageSrc"
          alt="No records illustration"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>
</div>
